import React, { createContext, useContext, useState, useEffect } from 'react';

const AuditLogContext = createContext();

export const useAuditLog = () => {
  const context = useContext(AuditLogContext);
  if (!context) {
    throw new Error('useAuditLog must be used within an AuditLogProvider');
  }
  return context;
};

export const AuditLogProvider = ({ children }) => {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    const savedLogs = localStorage.getItem('audit_logs');
    if (savedLogs) {
      try {
        setLogs(JSON.parse(savedLogs));
      } catch (e) {
        console.error('Failed to parse audit logs', e);
      }
    }
  }, []);

  const addLog = ({ userId, userName, entityId, fieldName, oldValue, newValue }) => {
    const newLog = {
      id: Date.now().toString(),
      timestamp: new Date().toISOString(),
      userId,
      userName,
      entityId,
      fieldName,
      oldValue: String(oldValue),
      newValue: String(newValue)
    };
    
    const updatedLogs = [newLog, ...logs];
    setLogs(updatedLogs);
    localStorage.setItem('audit_logs', JSON.stringify(updatedLogs));
  };

  const getLogsByEntity = (entityId) => {
    return logs.filter(log => log.entityId === String(entityId));
  };

  return (
    <AuditLogContext.Provider value={{ logs, addLog, getLogsByEntity }}>
      {children}
    </AuditLogContext.Provider>
  );
};